import superagent from 'superagent';
import defaultOptions from './default-options';

class RequestHandler {
  static retryRequest(request, options) {
    var { url, method } = request;
    var clone = superagent(method, url);
    // from https://github.com/visionmedia/superagent/pull/627/commits/c1e0ea0372ab2f5e8a4f3946e5e29f333f23cc7e
    // set existing querystrings
    clone._query = request._query;
    // set existing headers
    clone.header = request.header;
    clone._header = request._header;
    // set data
    clone._data = request._data;
    return RequestHandler.performRequest(clone, options);
  }
  static performRequest(req, options) {
    options = { ...defaultOptions, ...options };

    var {
      withCredentials,
      requestInterceptors,
      responseInterceptors,
      success,
      error,
      jsonp
    } = options;

    if (withCredentials) {
      req = req.withCredentials();
    }

    if (jsonp) {
      req = req.use(jsonp);
    }

    return new Promise(function(resolve, reject) {
      RequestHandler.invokeRequestInterceptors(req, requestInterceptors, options).then(
        ({ request }) => {
          request.end(function(err, res) {
            if (!err) {
              RequestHandler.invokeResponseInterceptors(
                request,
                res,
                responseInterceptors,
                options
              ).then(({ response }) => {
                if (response.ok) {
                  resolve(response);
                  success(response);
                } else {
                  reject(response);
                  error(response);
                }
              });
            } else {
              reject(err);
              error(err);
            }
          });
        }
      );
    });
  }
  static invokeRequestInterceptors(req, interceptors = [], options = {}) {
    return interceptors.reduce((resolved, interceptor) => {
      return resolved.then(({ request }) => {
        return interceptor(request, options);
      });
    }, Promise.resolve({ request: req }));
  }
  static invokeResponseInterceptors(req, res, interceptors = [], options = {}) {
    return interceptors.reduce((resolved, interceptor) => {
      return resolved.then(({ response }) => {
        return interceptor(req, response, options);
      });
    }, Promise.resolve({ response: res }));
  }
  static get(url, data, options) {
    var request = superagent.get(url, data);
    return RequestHandler.performRequest(request, options);
  }
  static post(url, data, options) {
    var request = superagent.post(url, data);
    return RequestHandler.performRequest(request, options);
  }
  static patch(url, data, options) {
    var request = superagent.patch(url, data);
    return RequestHandler.performRequest(request, options);
  }
  static put(url, data, options) {
    var request = superagent.put(url, data);
    return RequestHandler.performRequest(request, options);
  }
  static del(url, data, options) {
    var request = superagent.del(url, data);
    return RequestHandler.performRequest(request, options);
  }
}

export default RequestHandler;
